import { BulkExecutionError } from './../models/bulk-execution-error.model';
import { UtilsService } from './utils.service';
import { SortConfiguration } from './../components/generics/data-table/data-table.component';
import { Office } from './../models/office.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '../models/ID.model';

@Injectable({
    providedIn: 'root'
})
export class OfficesService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getOffices(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/oficinas';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<Office[]>(url, { headers, observe: 'response', params });
    }

    getOfficeById(id: ID) {
        return this.http.get<Office>(`/oficinas/${id}`);
    }

    deleteOffice(officeId: ID) {
        return this.http.delete(`/oficinas/${officeId}`);
    }

    createOffice(office: Office) {
        return this.http.post<Office>(`/oficinas`, office);
    }

    editOffice(office: Office) {
        return this.http.put<Office>(`/oficinas/${office.id}`, office);
    }

    bulkLoad(offices: Office[]) {
        return this.http.post<BulkExecutionError[]>(`/oficinas/creacion-masiva`, offices);
    }

    isAvailable(key: string, value: any) {
        return this.http.post<{ disponible: boolean }>(`/oficinas/disponibilidad`, { campo: key, valor: value });
    }

    getOfficesUsingService(serviceId: ID) {

        return this.http.get<Office[]>(`/oficinas/servicio/${serviceId}`, {
            headers: {
                'page-size': String(1000)
            }
        });
    }
}
